import { get } from 'helpers/api';

export const getLocation = zip => get(`/locations/${encodeURIComponent(zip)}`);
